/* eslint-disable react/prop-types */
import { Link } from "react-router-dom";

/**
 * Consent checkbox conforme a la Ley 21.719 (consentimiento informado,
 * específico, libre, inequívoco, revocable).
 *
 * Reglas obligatorias:
 *  - JAMÁS marcado por defecto.
 *  - Texto claro indicando qué dato, para qué finalidad y a qué política refiere.
 *  - El submit del formulario debe bloquearse si no está marcado.
 */
export default function ConsentCheckbox({ checked, onChange, testid, children }) {
  return (
    <label
      className="flex items-start gap-3 select-none cursor-pointer text-xs text-gray-700 leading-relaxed"
      data-testid={`${testid}-wrapper`}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={testid}
        className="mt-0.5 w-4 h-4 shrink-0 accent-[#0B2447] cursor-pointer"
      />
      <span>{children}</span>
    </label>
  );
}

/** Default ARCOP scan consent message used on the Home scan form. */
export function ScanConsentText() {
  return (
    <>
      Autorizo a <b>borra-me.com</b> a tratar mi <b>nombre y RUT</b> con la
      finalidad <b>específica</b> de escanear los brokers chilenos y mostrarme
      los resultados. He leído la{" "}
      <Link to="/legal/privacidad" target="_blank" className="underline">Política de Privacidad</Link>{" "}
      y los{" "}
      <Link to="/legal/terminos" target="_blank" className="underline">Términos</Link>{" "}
      (Ley 21.719, art. 12).
    </>
  );
}

/** Default registration consent message used on the Register page. */
export function RegisterConsentText() {
  return (
    <>
      Acepto los{" "}
      <Link to="/legal/terminos" target="_blank" className="underline">Términos y Condiciones</Link>{" "}
      y la{" "}
      <Link to="/legal/privacidad" target="_blank" className="underline">Política de Privacidad</Link>{" "}
      de borra-me.com, y autorizo el tratamiento de mis datos personales para la
      ejecución del servicio (Ley 21.719). Sé que puedo revocar este
      consentimiento en cualquier momento desde mi panel.
    </>
  );
}
